import React, {Component} from 'react';
import { ButtonToolbar, SplitButton, DropdownButton, MenuItem, Pagination, Button, Form, FormControl, FormGroup, InputGroup, Row, Col } from 'react-bootstrap';
import { Box } from 'reactjs-admin-lte';
import FontAwesome from 'react-fontawesome';
import Select from 'react-select';
import Moment from 'moment';
import StockStore from '../../stores/StockStore';
import IframeModal from '../../component/element/IframeModal'
import './Stock.css';
import ExportExcelModal from '../../component/ExportExcelModal';
import ReportMobileTable from '../report/ReportMobileTable'
import {connect} from 'react-redux'
const NotificationSystem = require('react-notification-system');
class StockTransactionReport extends Component {

  constructor(props){
    super(props)

    const yTh = parseInt(Moment().format('YYYY')) + 543
    const optionsYear = []

    for (var i = yTh; i >= 2557; i--) {
      optionsYear.push({
        value: i,
        label: i
      });
    }
    let {messages} = this.props
    const optionsMonth = [
      { value: 0, label: messages['All Year'] },
      { value: '01', label: messages['January'] },
      { value: '02', label: messages['February'] },
      { value: '03', label: messages['March'] },
      { value: '04', label: messages['April'] },
      { value: '05', label: messages['May'] },
      { value: '06', label: messages['June'] },
      { value: '07', label: messages['July'] },
      { value: '08', label: messages['August'] },
      { value: '09', label: messages['September'] },
      { value: '10', label: messages['October'] },
      { value: '11', label: messages['November'] },
      { value: '12', label: messages['December'] }
    ];

    const optionsInOut = [
      { value: '', label: messages['Import AND Export'] },
      { value: 'import', label: messages['In'] },
      { value: 'export', label: messages['Out'] },
      { value: 'request_purchase', label: messages['Request Purchase'] },
      { value: 'request_by', label: messages['Requester'] }
    ];

    const optionsToolType = [
      { value: 'any', label: messages['Any'] },
      { value: 'tool', label: messages['Tool'] },      
      { value: 'genpart', label: messages['Genpart'] },      
      { value: 'officemate', label: messages['Officemate'] },
      { value: 'color', label: messages['Color'] }
    ];

    this.state = { 
      loading: false,
      showEE:false,
      dataExcel:[],
      optionsYear: optionsYear, 
      optionsMonth: optionsMonth, 
      optionsInOut: optionsInOut,
      optionsToolType: optionsToolType,
      length: 10,
      totalPage: 0,
      activePage: 1,
      data: [],
      defaultType: '',
      defaultDay:0,
      defaultMonth: 0,
      defaultYear: yTh,
      trWidth: "50px",
      setData: [],
      defaultToolType: 'any',
      car_registration_no_search: '',
      placeholder: messages['Search Car Registration'],
      see_more: []
    }
  }

  componentDidMount(){
    
  }

  componentWillReceiveProps(newProps){
    
    if(newProps.show && newProps.show!==this.props.show){
      this.loadStockTransaction()
    }
  }

  loadStockTransaction(page = 1, year = this.state.defaultYear-543, month = 0, record_type = '', tool_type = '', q = '') {
    // let that = this
    this.setState({loading: true})
    
    if (page == 1) {
      var start = 0
      this.setState({ activePage: page })
    } else {
      var start = (page * 10) - 10
    }

    let {setData} = this.state
    setData['type'] = this.props.tool
    setData['year'] = year
    setData['month'] = month
    setData['record_type'] = record_type
    setData['start'] = start
    setData['q'] = q

    if (this.props.report===true){
      setData['type'] = this.state.defaultToolType      
    }

    this.props.loadData(setData)
  }
  

  handleSelect(e) { 
    this.setState({ activePage: e })
    this.loadStockTransaction(e, this.state.defaultYear - 543, this.state.defaultMonth, this.state.defaultType, this.state.defaultToolType, this.state.car_registration_no_search)
  }

  loadStockTransactionRecordAllItem(){
    let {defaultYear,defaultMonth,defaultDay,defaultType,car_registration_no_search} = this.state
    let that = this
    StockStore.loadStockTransactionRecordAllItem(this.props.tool,defaultYear-543,defaultMonth,defaultDay,defaultType,car_registration_no_search,function(result){
      that.setState({dataExcel:result.data})
    },function(error){

    })
  }

  onYearChange(e) {
    var year = e.value - 543

    this.setState({ defaultYear: e.value })
    this.loadStockTransaction(1, year, this.state.defaultMonth, this.state.defaultType, this.state.defaultToolType, this.state.car_registration_no_search)
  }

  onMonthChange(e) {
    this.setState({ defaultMonth: e.value })
    this.loadStockTransaction(1, this.state.defaultYear - 543, e.value, this.state.defaultType, this.state.defaultToolType, this.state.car_registration_no_search)
  }

  onRecordTypeChange(e) {
    let {messages} = this.props
    let {placeholder} = this.state
    if (e.value==='request_by')
      placeholder = messages['Search Requester']
    else 
      placeholder = messages['Search Car Registration']

    this.setState({defaultType:e.value,placeholder:placeholder})
    this.loadStockTransaction(1, this.state.defaultYear - 543, this.state.defaultMonth, e.value, this.state.defaultToolType, this.state.car_registration_no_search)
  }

  onToolTypeChange(e) {
    this.setState({ defaultToolType: e.value })
    this.loadStockTransaction(1, this.state.defaultYear - 543, this.state.defaultMonth, this.state.defaultType, e.value, this.state.car_registration_no_search)
  }

  onPrintClick(recordid, e) {
    let url = ''
    if (process.env.NODE_ENV === "development") {
      url  = 'https://demo2.bigfix.co/korat/pdf/?sr='+recordid+'&file=stockrecord_doc'
    } else{
      url = './pdf/?sr='+recordid+'&file=stockrecord_doc'
    }
    this.refs.iframe.loadUrl(url)
  }

  onRemoveClick(recordid){
    StockStore.deleteStockRecord(recordid,(result)=>{
      //Do somthing
    },function(error){

    })
  }

  onButtonSelect(recordid,key) {
    let {messages} = this.props
    if (key==='1') {
      this.onNewClick(recordid)
    } else if (key==='2') {
      this.onPrintClick(recordid)
    } else if (key==='3') {
      this.onRemoveClick(recordid)
    } else if (key==='4') {
      StockStore.updatePRComplete(recordid,(result)=>{
        if (result.status==='OK') {
          this.loadStockTransaction(1, this.state.defaultYear-543, this.state.defaultMonth, this.state.defaultType, this.state.defaultToolType, this.state.car_registration_no_search)
          this.refs.notificationSystem.addNotification({
            title:messages['Notice'],
            message:messages['Change Status'],
            level: 'info',
            position:'tc'
          });
        }
      })
    }
  }

  onNewClick(recordid){
    if(this.props.onDocNew!==undefined){
      this.props.onDocNew(recordid)
    }
  }

  onTextChange(e) {
    this.setState({car_registration_no_search:e.target.value})
  }

  onSearchKeyPress(e) {
    if (e.charCode == 13) {
      this.loadStockTransaction(1, this.state.defaultYear - 543, this.state.defaultMonth, this.state.defaultType, this.state.defaultToolType, this.state.car_registration_no_search)
    }
  }

  onSearchClick(e) {
    this.loadStockTransaction(1, this.state.defaultYear - 543, this.state.defaultMonth, this.state.defaultType, this.state.defaultToolType, this.state.car_registration_no_search)
  }

  onMenuItemSelect(key){
    if(key==='export_excel'){
      this.loadStockTransactionRecordAllItem()
      setTimeout(()=>{
        this.setState({showEE:true})
      },100)
    }
  }

  onPOClick(poNo){
    if(this.props.onPOClick!==undefined){
      this.props.onPOClick(poNo)
    }
  }

  renderTable() {
    let {messages} = this.props
    return(
      <div className='display-overflow'>
        <table className="table table-responsive table-hover table-bordered-solid">
          <thead>
            <tr>
              <th style={{width: "150px"}}>{messages['Day']}</th>
              <th style={{width: "100px"}}>{messages['Time']}</th>
              <th style={{width: "150px"}}>{messages['Type']}</th>
              <th style={{width:'170px'}}>{messages['Requester']}</th>
              <th style={{width:'170px'}}>{messages['Approvers']}</th>
              <th style={{width:'150px',display:(this.props.report===true?'':'none')}}>{messages['Purchaser']}</th>
              <th style={{width:'150px',display:(this.props.report===true?'':'none')}}>{messages['Shop Order']}</th>
              <th style={{width:'150px',display:(this.props.report===true?'':'none')}}>{messages['Order Number']}</th>
              <th style={{width:'150px'}}>{messages['Car Registration']}</th>
              <th style={{width:'350px'}}>{messages['List']}</th>
              <th style={{width: (this.props.report===true?'250px':'350px')}}>{messages['Description']}</th>
              <th style={{width: '50px'}}></th>
            </tr>
          </thead>
          <tfoot>
            <tr>
              <th style={{width: "150px"}}>{messages['Day']}</th>
              <th style={{width: "100px"}}>{messages['Time']}</th>
              <th style={{width: "150px"}}>{messages['Type']}</th>
              <th style={{width:'170px'}}>{messages['Requester']}</th>
              <th style={{width:'170px'}}>{messages['Approvers']}</th>
              <th style={{width:'150px',display:(this.props.report===true?'':'none')}}>{messages['Purchaser']}</th>
              <th style={{width:'150px',display:(this.props.report===true?'':'none')}}>{messages['Shop Order']}</th>
              <th style={{width:'150px',display:(this.props.report===true?'':'none')}}>{messages['Order Number']}</th>
              <th style={{width:'150px'}}>{messages['Car Registration']}</th>
              <th style={{width:'350px'}}>{messages['List']}</th>
              <th style={{width: (this.props.report===true?'250px':'350px')}}>{messages['Description']}</th>
              <th style={{width: '50px'}}></th>
            </tr>
          </tfoot>
          <tbody>
            { this.renderRowData() }      
          </tbody>
        </table>
      </div>  
    );
  }

  getDate(added_date,type) {
    let date = added_date
    if (type==='day')
      date = date.substring(0, 10)
    else
      date = date.substring(11, 19)

    return date
  }

  getRecordTypeText(item){
    let {messages} = this.props
    if (item.record_type == 'export') {
      return  messages['Export']
    } else if (item.record_type == 'import') {
      return messages['Import']
    } else if (item.record_type == 'request_purchase') {
      return messages['Purchase Order Request']
    }else{
      return ""
    }
  }

  renderRefPONO(poNo){
    if(poNo!==''){
      return (<div>{poNo}<FontAwesome name='file-text-o' className='text-orange'/></div>)
    }else{
      return ('')
    }
  }

  renderRowData() { 
    let {messages} = this.props
    if (this.props.loading){
      return (<tr><td colSpan={5}><FontAwesome name='spinner' />{messages['Fetching']}...</td></tr>)
    } else if (this.props.data.length===0){
      return (<tr><td colSpan={5}>{messages['Data Not Found']}...</td></tr>)
    }else{      
      return this.props.data.map((item, index) => (
                    
            <tr key={index}>
              <td>{this.getDate(item.added_date,'day')}</td>
              <td>{this.getDate(item.added_date,'time')}</td>
              <td>{ this.getRecordTypeText(item) }</td>
              <td>{ item.request_by }</td>
              <td>{ item.response_by }</td>
              <td style={{display:(this.props.report===true?'':'none')}}>{item.purchase_order_by}</td>
              <td style={{display:(this.props.report===true?'':'none')}}>{item.shop_name}</td>
              <td style={{display:(this.props.report===true?'':'none')}} onClick={this.onPOClick.bind(this,item.ref_po_no)}>{this.renderRefPONO(item.ref_po_no)}</td>
              <td>{ (item.car_registration_no!==undefined)?item.car_registration_no:'' }</td>
              {/* <td>{this.renderItems(item.items)}</td> */}
              <td>{this.renderSeeMoreItem(item.items,index)}</td>
              <td>{ item.description }</td>
              <td>
                <Button style={{display:(this.props.report===true?'none':'')}} onClick={ this.onPrintClick.bind(this, item.recordid) }><FontAwesome name='print'/></Button>
                <DropdownButton
                  style={{display:(this.props.report===true?'':'none')}}
                  bsStyle={'primary'}
                  title={item.pr_complete==='1'?messages['Completed PO']:'รอสั่งซื้อ'}
                  key={1}
                  id={'split-button-pull-right'}
                  pullRight
                  onSelect={this.onButtonSelect.bind(this,item.recordid)}
                >
                  <MenuItem eventKey="1" style={{display:(item.pr_complete==='1'?'none':'')}}><FontAwesome name='plus' className='color-blue' />{messages['Create Purchase Order']}</MenuItem> {/* style={{display:(item.ref_po_no!==''?'none':'')}} */}
                  <MenuItem eventKey="2"><FontAwesome name='print' style={{color:'#d81b60'}} />{messages['Print Purchase Order']}</MenuItem>
                  <MenuItem eventKey="4" style={{display:(item.pr_complete==='1'?'none':'')}}><FontAwesome name='check' style={{color:'#00a65a'}} />{messages['Completed PO']}</MenuItem>
                  <MenuItem eventKey="3" style={{display:(item.ref_po_no!=='none'?'none':'')}}><FontAwesome name='remove' className='color-red' />{messages['Cancel']}</MenuItem>
                </DropdownButton>
              </td>    
            </tr>
          )) 
        }    
  }

  // renderItems(items) {
  //   if (items.length===0||items===undefined) {
  //     return ('')
  //   } else {
  //     return(
  //       items.map((item,index)=> {
  //         return(
  //           <div key={index}>
  //             <p>{' - ' + item.description + ' '+this.props.messages['Quantity']+' ' + item.quantity+' '+(item.unit!==''&&item.unit!==undefined&&item.unit!==null?item.unit:'รายการ')}</p>
  //           </div>
  //         )
  //       })
  //     )
  //   }
  // }
  
  onSeeMoreOption(index) {
    let {see_more} = this.state
    see_more.push(index)
    this.setState({see_more:see_more})
  }

  onCloseSeeMoreOption(index) {
    let {see_more} = this.state
    let key = see_more.indexOf(index)
    if (key!==-1)
      see_more.splice(key,1)
    this.setState({see_more:see_more})
  }

  renderSeeMoreItem(items,index) {
    let {see_more} = this.state
    let {messages} = this.props
    return(
      items.map((sitem,sindex)=> {
        if (see_more.indexOf(index)!==-1) {
          return(
            <div key={sindex} style={{marginBottom:'10px'}}>
              <p>{(sindex+1)+'. ' + (sitem.detail!==undefined?sitem.detail:sitem.description) + ' '+this.props.messages['Quantity']+' ' + sitem.quantity+' '+(sitem.unit!==''&&sitem.unit!==undefined&&sitem.unit!==null?sitem.unit:messages['List'])}</p>
              {items.length>3&&sindex===items.length-1
              ?
              <Button
                bsStyle={'link'}
                style={{padding:'0'}}
                onClick={this.onCloseSeeMoreOption.bind(this,index)}
              >
                {messages['Hide See more']}...
              </Button>
              :''}
            </div>
          )
        } else {
          if (sindex<3) {
            return(
              <div key={sindex} style={{marginBottom:'10px'}}>
                <p>{(sindex+1)+'. ' + (sitem.detail!==undefined?sitem.detail:sitem.description) + ' '+this.props.messages['Quantity']+' ' + sitem.quantity+' '+(sitem.unit!==''&&sitem.unit!==undefined&&sitem.unit!==null?sitem.unit:messages['List'])}</p>
                {items.length>3&&sindex===2
                ?
                <Button
                  bsStyle={'link'}
                  style={{padding:'0'}}
                  onClick={this.onSeeMoreOption.bind(this,index)}
                >
                  {messages['See more']}...
                </Button>
                :''}
              </div>
            )
          } else {
            return('')
          }
        }  
      })
    )
  }

  renderMobileTable() {
    let {data,messages} = this.props
    let fieldMap = {title:'request_by',amount:'record_type_text',sub_title:'stock_type_text',date:'added_date',status:'',sub_status:''}
    let _data = []
    _data = data.map((item,index)=>{
      let _item = item
      _item = Object.assign({record_type_text:(item.record_type==='export'?messages['Export']:item.record_type==='import'?messages['Import']:messages['Purchase Order Request']),stock_type_text:(item.stock_type==='tool'?messages['Tool']:item.stock_type==='genpart'?messages['Genpart']:messages['Officemate'])}, _item)
      return _item
    })
    return(
      <div>
        <ReportMobileTable
          itemlist={_data}
          fieldMap={fieldMap}
          keyIndex={'recordid'}
          numberFormat={false}
        />
      </div>
    )
  }

  render(){
    let {showEE,dataExcel,defaultType} = this.state
    let {isMobile,messages} = this.props
    let title = messages['Menu']
    const headerTitles = [
      {title:messages['Day'],field:'record_date'},
      {title:messages['Time'],field:'record_time'},           
      {title:messages['Part Name'],field:'description'},  
      {title:messages['Type'],field:'record_type_text'},
      {title:messages['Quantity'],field:'quantity'},      
      {title:messages['Car Registration'],field:'car_registration_no'},      
      {title:(defaultType===''||defaultType==='request_by'?messages['Request By']:defaultType==='import'?messages['Import By']:defaultType==='request_purchase'?messages['Requester Purchase Order']:messages['Export By']),field:'request_by'},   
      {title:messages['Remark'],field:'remark'},   
    ]
    return (
      <Row>
        <Col md={12}>
          <Box loading={this.props.loading}>
            <Box.Header border={true}>
              <Box.Title>
                {this.props.report===true?messages['Request Purchase Order Table']:messages['Search For In/Out Item']}            
              </Box.Title>
              
              <Box.Tools className='pull-right'>
              
                <ButtonToolbar>                                            
                  <SplitButton bsStyle={'primary'} title={title} id={'po-menu-options'} onSelect={this.onMenuItemSelect.bind(this)}>
                    <MenuItem eventKey="export_excel"><FontAwesome name='file-excel-o' className='text-green'/>&nbsp;{messages['Download Excel']}</MenuItem>                
                  </SplitButton>
                </ButtonToolbar>                     
              </Box.Tools> 
            </Box.Header>
            <Box.Body>
              <Form inline style={{marginBottom:'5px'}}>
                <FormGroup>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    value={ this.state.defaultYear }
                    options={this.state.optionsYear}
                    style={{ width: "90px" }}
                    onChange={ this.onYearChange.bind(this) }
                  />
                </FormGroup>
                {' '}
                <FormGroup>
                  <Select
                    clearable={false}
                    name="form-field-name"
                    value={ this.state.defaultMonth }
                    options={this.state.optionsMonth}
                    style={{ width: "100px" }}
                    onChange={ this.onMonthChange.bind(this) }
                  />
                </FormGroup>
                {' '}
                <FormGroup style={{display:(this.props.report===true?'none':'')}}> 
                  <Select
                    clearable={false}
                    name="form-field-name"
                    value={ this.state.defaultType }
                    options={this.state.optionsInOut}
                    style={{ width: "150px" }}
                    onChange={ this.onRecordTypeChange.bind(this) }
                  />
                </FormGroup>
                {' '}
                <FormGroup>
                  <InputGroup>
                    <InputGroup>
                      <FormControl type="text" placeholder={this.state.placeholder} onChange={this.onTextChange.bind(this)} onKeyPress={this.onSearchKeyPress.bind(this)} />
                      <InputGroup.Addon className="btn" onClick={this.onSearchClick.bind(this)}>
                        <FontAwesome name='search' />
                      </InputGroup.Addon>
                    </InputGroup>
                  </InputGroup>
                </FormGroup>
                {' '}
                <span style={{display:(this.props.report===true?'':'none')}}>
                  {messages['Select Type']}
                  {' '}
                  <FormGroup> 
                    <Select
                      clearable={false}
                      name="form-field-name"
                      value={ this.state.defaultToolType }
                      options={this.state.optionsToolType}
                      style={{ width: "150px" }}
                      onChange={ this.onToolTypeChange.bind(this) }
                    />
                  </FormGroup>
                </span>
              </Form>
              {isMobile?this.renderMobileTable():this.renderTable()}
              <div className="text-right">
                <Pagination
                  prev={messages['Previous']}
                  next={messages['Next']}
                  first={false}
                  last={false}
                  ellipsis
                  boundaryLinks
                  items={ this.props.totalPage }
                  maxButtons={5}
                  activePage={this.state.activePage}
                  onSelect={this.handleSelect.bind(this)}
                />
              </div>
              <IframeModal ref='iframe' title={messages['Print Document']} />
              <NotificationSystem ref="notificationSystem" />
              <ExportExcelModal show={showEE} 
              onHide={()=>{this.setState({showEE:false})}}
              data={dataExcel} 
              headerTitles={headerTitles}/>
            </Box.Body>
          </Box>  
        </Col> 
      </Row>  
    );
  }
}

StockTransactionReport.defaultProps = {
  report: false,
  show:false,
  data:[],
  loading:false
}

export default connect(
  (state) => ({messages: state.message.view.stock.StockTransactionReport}),null,null,{withRef:true},
)(StockTransactionReport);





// WEBPACK FOOTER //
// ./src/view/stock/StockTransactionReport.js